import { Routes } from '@angular/router';
import { adminGuard } from '../../core/guards';

export const exerciseMatchesRoutes: Routes = [
  {
    path: 'exercises/match/:matchId',
    loadComponent: () =>
      import('./pages/detail/exercise-match-detail.component').then(
        (m) => m.ExerciseMatchDetailComponent,
      ),
  },
  {
    path: 'exercises/match/:matchId/admin',
    loadComponent: () =>
      import('./pages/admin/exercise-match-admin.component').then(
        (m) => m.ExerciseMatchAdminComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'exercises/match/:matchId/hd',
    loadComponent: () =>
      import('./pages/view/exercise-match-view.component').then(
        (m) => m.ExerciseMatchViewComponent,
      ),
    data: { hideNavbar: true, fullscreen: true },
  },
];
